import React, { FC } from 'react';
import { MdError } from 'react-icons/md';
import {
  Text,
  Modal,
  Button,
  Center,
  Heading,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  useToast,
  useDisclosure,
  MenuItem,
} from '@chakra-ui/react';
import DecomissionedSvg from 'svg/Decommissioned';
import { useDeleteReportMutation } from 'api/mutations/deleteReportMutation';

type Props = {
  inventoryReportId: string;
};

export const DeleteReportMenuItem: FC<Props> = ({ inventoryReportId }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate, isLoading } = useDeleteReportMutation();

  return (
    <>
      <MenuItem
        icon={<DecomissionedSvg />}
        isDisabled={isLoading}
        color="red.500"
        _hover={{ color: 'red.600' }}
        onClick={onOpen}>
        Delete Report
      </MenuItem>
      <Modal
        size="2xl"
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="30px">
          <ModalCloseButton _focus={{ outline: 'none' }} />
          <ModalBody textAlign="center">
            <Center>
              <MdError size="100px" fill="red" />
            </Center>
            <Heading
              color="support.500"
              textAlign="center"
              fontSize="30px"
              whiteSpace="pre-line">
              Are you sure you want to delete this Harvest Report?
            </Heading>
            <Text my={4} fontSize="20px">
              Deleting it will also remove the attached Impact report. This
              action can't be undone.
            </Text>
            <Center mb={5}>
              <Button mr={4} w="150px" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                isLoading={isLoading}
                onClick={() => {
                  mutate(inventoryReportId);
                  onClose();
                }}>
                Yes, Delete
              </Button>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
